import { Injectable } from '@angular/core';
import { Energietraeger } from '../../domain/model/energietraeger';

@Injectable({
    providedIn: 'root',
})
export class AnlagentypIconService {

    public static readonly DEFAULT_ICON = 'innogy_picto_lightning_n_RGB.png';
    public static readonly ICON_OTHERTYPES = 'innogy_picto_lightning_n_RGB.png';
    public static readonly ICON_WATER = 'innogy_picto_waterdrop_n_RGB.png';
    public static readonly ICON_WIND = 'innogy_picto_windmill_n_RGB.png';
    public static readonly ICON_BHKW = 'innogy_picto_business_small_n_RGB.png';
    public static readonly ICON_PHOTOVOLTAIC = 'innogy_picto_sun_n_RGB.png';
    public static readonly ICON_BIO = 'innogy_picto_leaf_n_RGB.png';

    public static readonly ENERGIETRAEGER_TO_ICON: Map<Energietraeger, string> = new Map([
        // other types
        [
            Energietraeger.SONSTIGES,
            AnlagentypIconService.ICON_OTHERTYPES,
        ],
        [
            Energietraeger.ABFALL,
            AnlagentypIconService.ICON_OTHERTYPES,
        ],

        // water
        [
            Energietraeger.PUMPSPEICHER,
            AnlagentypIconService.ICON_WATER,
        ],
        [
            Energietraeger.LAUFWASSER,
            AnlagentypIconService.ICON_WATER,
        ],
        [
            Energietraeger.SPEICHERWASSER,
            AnlagentypIconService.ICON_WATER,
        ],

        // bio and geo
        [
            Energietraeger.GASE,
            AnlagentypIconService.ICON_BIO,
        ],
        [
            Energietraeger.BIOMASSE,
            AnlagentypIconService.ICON_BIO,
        ],
        [
            Energietraeger.GASE_ERDGAS,
            AnlagentypIconService.ICON_BIO,
        ],
        [
            Energietraeger.GEOTHERMIE,
            AnlagentypIconService.ICON_BIO,
        ],

        // wind
        [
            Energietraeger.WINDENERGIE_OFFSHORE,
            AnlagentypIconService.ICON_WIND,
        ],
        [
            Energietraeger.WINDENERGIE_ONSHORE,
            AnlagentypIconService.ICON_WIND,
        ],

        // bhkw / ikw
        [
            Energietraeger.KERNENERGIE,
            AnlagentypIconService.ICON_BHKW,
        ],

        // Photovoltaic
        [
            Energietraeger.SOLAR,
            AnlagentypIconService.ICON_PHOTOVOLTAIC,
        ],
    ]);

    public getIconNameForEnergietraeger(energietraeger: Energietraeger): string {
        if (energietraeger) {
            const iconPath = AnlagentypIconService.ENERGIETRAEGER_TO_ICON.get(energietraeger);
            if (iconPath) {
                return iconPath;
            }
        }

        return AnlagentypIconService.DEFAULT_ICON;
    }
}
